import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "74c2c329-06a9-43cf-b7e5-eb83f926f2fb", content: "36 Hz", options: {} },
  { id: "1822ee25-864a-4a6a-8d57-457c383efc92", content: "2266 Hz", options: {} },
  { id: "26bdc74e-f896-46da-88a0-b700e7bca811", content: "4341 Hz", options: {} },
  { id: "54d4cd1b-bc62-46fe-9b79-db19d511446a", content: "113 Hz", options: {} },
  { id: "ff240e4d-533b-4579-9192-57cd55b69729", content: "361 Hz", options: {} },
  { id: "5b11ebd0-9fd8-4fd2-b2a7-ee7f3e809a25", content: "691 Hz", options: {} },
];

export const task: Task = {
  id: "37438cdb-0052-40c6-8cff-09c85d6a64a8",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["ff240e4d-533b-4579-9192-57cd55b69729"],
};
